import * as React from 'react';
import { createContext, useContext } from 'react';
import { connectStateResults } from 'react-instantsearch-core';
import { useAlgoliaIndex } from './hooks/use-algolia-index.js';

const AlgoliaDataContext = /*#__PURE__*/ createContext(null);
AlgoliaDataContext.displayName = 'AlgoliaDataContext';
function useAlgoliaData() {
    const context = useContext(AlgoliaDataContext);
    if (context === null) {
        throw new Error('No AlgoliaDataContext available.');
    }
    return context;
}
function AlgoliaDataProvider({ allSearchResults , children , searching , searchResults , searchState  }) {
    var ref, ref1, ref2, ref3, ref4;
    const productType = searchState === null || searchState === void 0 ? void 0 : (ref = searchState.refinementList) === null || ref === void 0 ? void 0 : (ref1 = ref.productType) === null || ref1 === void 0 ? void 0 : ref1[0];
    const mappedResults = useAlgoliaIndex(searchResults === null || searchResults === void 0 ? void 0 : searchResults.hits, productType);
    const value = {
        allSearchResults,
        facetOrder: searchResults === null || searchResults === void 0 ? void 0 : (ref2 = searchResults.renderingContent) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.facetOrdering) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.facets) === null || ref4 === void 0 ? void 0 : ref4.order,
        mappedResults,
        searching,
        searchQuery: searchResults === null || searchResults === void 0 ? void 0 : searchResults.query,
        searchState,
        total: searchResults === null || searchResults === void 0 ? void 0 : searchResults.nbHits
    };
    return /*#__PURE__*/ React.createElement(AlgoliaDataContext.Provider, {
        value: value
    }, children);
}
var AlgoliaDataProvider$1 = connectStateResults(AlgoliaDataProvider);

export { AlgoliaDataProvider, AlgoliaDataProvider$1 as default, useAlgoliaData };
//# sourceMappingURL=AlgoliaDataProvider.js.map
